import { useSelector } from 'react-redux';
import { isAmbassadorTesting } from 'services/ambassador';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';

// Embaixador com a ferramenta em teste: é quem vê a barra de feedback dentro
// dela. Quem só é alfa usa a ferramenta sem a barra.
export function useAmbassadorTesting(toolSlug: string): boolean {
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  return isAmbassadorTesting(profile.ambassador, toolSlug);
}

export default useAmbassadorTesting;
